import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import {
  getConsentPolicyStateRefs,
  consentPolicyUiTypeMapper,
  withConsentPolicyProps,
  consentPolicyPropsDeps,
} from '@wix/thunderbolt-elements/components/ConsentPolicyWrapper/utils';
import { FacebookLikeBoxStateRefs } from '../FacebookLikeBox.types';

export const consetPolicyKeys = {
  componentNameKey: 'CookieConsent_Dataset_Component_FacebookLikeBox',
  componentNameDefault: 'Facebook Page Like',
};

/**
 * This mapper created so Lean's generated mapper won't override the results coming from the mapper in TB.
 */
export const props = withCompInfo<any, any, any>()(
  [...consentPolicyPropsDeps],
  (compInfo, carmiData) => {
    const originalProps = {
      ...carmiData,
    };
    return withConsentPolicyProps(
      compInfo,
      originalProps,
      consetPolicyKeys.componentNameKey,
      consetPolicyKeys.componentNameDefault,
    );
  },
);

export const stateRefs = withStateRefsValues<keyof FacebookLikeBoxStateRefs>([
  ...getConsentPolicyStateRefs(),
]);

export const uiType = consentPolicyUiTypeMapper;

export default createComponentMapperModel({ props, stateRefs, uiType });
